import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './lib/i18n'; // Initialize i18n
import './index.css';
import App from './App';
import { initGlobalErrorHandlers } from './lib/errorLogging';
import { ErrorBoundary } from './components/ErrorBoundary';

// Initialize global error handlers (window.onerror, unhandledrejection)
initGlobalErrorHandlers();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary componentName="App">
      <App />
    </ErrorBoundary>
  </StrictMode>
);
